import 'css-chunksrc/client/common/projectPortfolioTag/styles.scss';export default {
  "tag": "_tag_1qqsm_1",
  "icon": "_icon_1qqsm_11",
  "name": "_name_1qqsm_19",
  "removeIconBox": "_removeIconBox_1qqsm_27",
  "removeIcon": "_removeIcon_1qqsm_27"
};